export const TYPE_LABELS = {
    feedback: 'Feedback',
    bug: 'Bug report',
    doubt: 'Doubt',
};

export const TYPE_BADGES = {
    feedback: 'bg-info',
    bug: 'bg-danger',
    doubt: 'bg-secondary',
};

export const STATUS_LABELS = {
    new: 'New',
    read: 'Read',
    resolved: 'Resolved',
    archived: 'Archived',
};

export const STATUS_BADGES = {
    new: 'bg-warning',
    read: 'bg-info',
    resolved: 'bg-success',
    archived: 'bg-secondary',
};
